export default __webpack_public_path__ + "static/17_32-66a2fe15638ec19060b414e9df0c6cd0.png";